import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { unlockSecurity } from "../../../../../API/nimbleAPI";
import { enqueueSnackbar } from "notistack";
import { Loader } from "../../../../../HelperFunctions/HelperFunctions";
 

const SecurityLockDialog = ({ open, onClose, onSuccess,CorpID }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  

  // const handleUnlock = async () => {
  //   if (!password) return;

  //   try {
  //     setLoading(true);

  //     if (password === STATIC_PASSWORD) {
  //       onSuccess();
  //       setPassword("");
  //       onClose();
  //     } else {
  //       alert("Invalid password");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const handleUnlock = async () => {
   

  try {
    setLoading(true);
    // console.log("corpiddddddddddd",CorpID)

    const response = await unlockSecurity(CorpID.ID, password);
    // console.log("response",response)

    if (response?.status === true) {
      onSuccess();
      setPassword("");
      onClose();
    } else {
      enqueueSnackbar("Invalid password",{variant:"error"})
    }
  } catch (error) {
    console.error("Unlock failed:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 500,
          color: "#2070ccff",
          fontSize: "0.9rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 0.5,
          borderBottom: "1px solid #c9d7e6",
        }}
      >
        Security Lock
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            color: "#666",
            padding: "4px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2, mt: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "20%",
            width: "100%",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              // minWidth: '70px',
              color: "#333",
              fontSize: "0.875rem",
              fontWeight: 400,
            }}
          >
            Password<span style={{ color: "red", marginLeft: 2 }}>*</span>
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            InputProps={{
              sx: {
                backgroundColor: "#fff",
                fontSize: "0.875rem",
                height: "32px",
                "& input": {
                  padding: "6px 8px",
                },
              },
            }}
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d0d0d0",
                },
                "&:hover fieldset": {
                  borderColor: "#1976d2",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1976d2",
                },
              },
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={!password || loading}
          onClick={handleUnlock}
          startIcon={<LockOpenIcon />}
          sx={{
            textTransform: "none",
            fontSize: "0.875rem",
            fontWeight: 400,
            paddingX: 2,
            paddingY: 0.5,
            minWidth: "90px",
          }}
        >
          Unlock
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontSize: "0.875rem",
            fontWeight: 400,
            paddingX: 2,
            paddingY: 0.5,
            minWidth: "80px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
       {loading && <Loader loading={loading} />}
    </Dialog>
    
  );
  
};

export default SecurityLockDialog;
